import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ProductContainer from './ProductContainer';
import {incrementProduct, decrementProduct, setProduct, setProductConfig} from '../../product-picker/actions/product-picker';
import ContainerProps from './ProductWrapperComponent';
import { getTotalSelectedItems } from 'checkout/views/ticket-picker/selectors/selected-items';
import TicketPickerCardHeader from '../../ticket-picker/components/TicketPickerCardHeader';
import Translation from "../../../../shared/Translation";
import { getFetchedEventProducts } from '../../../selectors/event';

class ProductWrapper extends Component<ContainerProps> {
    renderProducts = () => {
        if (this.props.products) {
            return Object.values(this.props.products).sort((a, b) => a.position - b.position).map((product) => {
                return <ProductContainer key={product.product_id} productId={+product.product_id} />
            });
        }

        return;
    };

    render() {
        if(Object.keys(this.props.products).length === 0) {
            return null;
        }

        return(
            <TicketPickerCardHeader header={this.props.header !== undefined ? this.props.header : <Translation>{"checkout__add_ons"}</Translation>}>
                {this.renderProducts()}
            </TicketPickerCardHeader>
        )
    }
}

const mapStateToProps = state => {
    return {
        products: getFetchedEventProducts(state),
        selectedConfigurations: state.productPicker.selectedConfigurations,
        quantityArrays: state.productPicker.productsQuantityArrays,
        selectedItems: getTotalSelectedItems(state),
        header: state.ui.checkoutConfig.productsHeader,
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        incrementProduct,
        decrementProduct,
        setProduct,
        setProductConfig
    }, dispatch);
};

ProductWrapper.propTypes = {
    products: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductWrapper)
